<div class="sidebar-filters-content collapse-icon">
  <div class="collapse-default">
    <div class="card">
      <div class="card-header">
        <button class="row collapse-title btn p-0"
                (click)="isCollapsed = !isCollapsed"
                [attr.aria-expanded]="!isCollapsed"
                aria-controls="collapseExample"
                data-toggle="collapse"
                role="button">
          <h6>{{'TAX_CATEGORIES.TITLE' | translate}}</h6>
        </button>
      </div>

      <div [ngbCollapse]="isCollapsed" id="collapseExample">
        <div class="card">
          <div class="card-body">
            <div class="categories-list">
              <div class="category-item">
                <app-tax-category-display category="1"></app-tax-category-display>
                <div class="filter-check">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="taxCategorySelection[1]" id="zero-tax-category" (change)="checkCategory()"/>
                    <label class="custom-control-label" for="zero-tax-category"></label>
                  </div>
                  <label for="zero-tax-category" class="filter-details">
                    <div class="title">
                      {{'TAX_CATEGORIES.ZERO_TAX_TITLE' | translate}}
                    </div>
                    <div class="description">
                      {{'TAX_CATEGORIES.ZERO_TAX_DESCRIPTION' | translate}}
                    </div>
                  </label>
                </div>
              </div>
              <div class="category-item">
                <app-tax-category-display category="2"></app-tax-category-display>
                <div class="filter-check">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="taxCategorySelection[2]" id="partial-tax-category" (change)="checkCategory()"/>
                    <label class="custom-control-label" for="partial-tax-category"></label>
                  </div>
                  <label for="partial-tax-category" class="filter-details">
                    <div class="title">
                      {{'TAX_CATEGORIES.PARTIAL_TAX_TITLE' | translate}}
                    </div>
                    <div class="description">
                      {{'TAX_CATEGORIES.PARTIAL_TAX_DESCRIPTION' | translate}}
                    </div>
                  </label>
                </div>
              </div>
              <div class="category-item">
                <app-tax-category-display category="3"></app-tax-category-display>
                <div class="filter-check">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="taxCategorySelection[3]" id="full-tax-category" (change)="checkCategory()"/>
                    <label class="custom-control-label" for="full-tax-category"></label>
                  </div>
                  <label for="full-tax-category" class="filter-details">
                    <div class="title">
                      {{'TAX_CATEGORIES.FULL_TAX_TITLE' | translate}}
                    </div>
                    <div class="description">
                      {{'TAX_CATEGORIES.FULL_TAX_DESCRIPTION' | translate}}
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
